export default participants =>
  participants.filter(({ roles }) => !roles || !roles.includes('organizer'));
